import { ITypedReduxAction } from '../../types/redux/actionType';
import { ERequestTrigger } from '../../types/requestTrigger';
import { TChatListSetSucceedPayload } from '../chatList';

export enum ESpamListActionTypes {
  SetPending = 'chats/spamList/setPending',
  SetSucceed = 'chats/spamList/setSucceed',
  SetFailed = 'chats/spamList/setFailed',
}

export interface ISpamListRequest {
  timestampSpam?: number;
  /** Источник запроса, пишется в логи */
  trigger?: ERequestTrigger;
}

export type TSpamListActions =
  | ITypedReduxAction<ESpamListActionTypes.SetPending, ISpamListRequest>
  | ITypedReduxAction<ESpamListActionTypes.SetSucceed, TChatListSetSucceedPayload>
  | ITypedReduxAction<ESpamListActionTypes.SetFailed, void>;
